import { t } from 'i18next';

const validateMany = (funcs, data, name, fieldLabel) => {
    let err;
    for (let i = 0; i < funcs.length; i++) {
        const func = funcs[i];
        err = func(data, name, fieldLabel);
        if(typeof err === "string") {
            return err;
        }
    }
    return true;
};

const validationFunctions = {
    notEmpty: (data, name, fieldLabel) => (data[name] && true) ||  t('notEmpty', {PARAM: `${fieldLabel}`}),
    numericalInteger: (data, name, fieldLabel) => 
        Number.isInteger(parseInt(data[name])) ||  t('numericalInteger', {PARAM: `${fieldLabel}`}),
    numericalPositiveInteger: (data, name, fieldLabel) => (Number.isInteger(parseInt(data[name])) && 
        parseInt(data[name]) > 0)  || t('numericalInteger', {PARAM: `${fieldLabel}`}),
    numericalPositiveDecimal: (data, name, fieldLabel) => {
        const value = parseFloat(data[name]);
        return (!isNaN(value) && value > 0) || t('numericalInteger', {PARAM: `${fieldLabel}`});
    },
    regex: (rgx, message) => { // factory
        return (data, name, fieldLabel) => {
            if (rgx.test(data[name])) {
                return true;
            } else {
                return t('invalid_field', {FIELD: `${fieldLabel}` , MSG: `${message}` });
            }
        }
    },
    withAnother: (func, anotherName, anotherLabel) => { // factory
        return (data, _name, _fieldLabel) => 
            func(data, anotherName, anotherLabel)
    },
    rangeFloat(min, max, message) {
        return (data, name, _fieldLabel) => {
            const valueToValidate = parseFloat(data[name]);
            return (valueToValidate >= min && valueToValidate <= max || message);
        }
    },
    range: (min, max, message) => // factory
        (data, name, fieldLabel) => 
            (Number.isInteger(parseInt(data[name])) && parseInt(data[name]) >= min && parseInt(data[name]) <= max) || message,
    interval:(minFieldName, maxFieldName, message) => //factory
        (data) => (!data.hasOwnProperty(minFieldName) || !data.hasOwnProperty(maxFieldName)) || 
        (Number.isInteger(parseInt(data[minFieldName])) && Number.isInteger(parseInt(data[maxFieldName])) && 
            parseInt(data[minFieldName]) <= parseInt(data[maxFieldName])) || message,
    optional: (func) => { // factory, DEPRECATED, use optionalFunc instead
        return (data, name, fieldLabel) => (!data.hasOwnProperty(name) || data[name] == "") ||
            func(data, name, fieldLabel)
    },
    maxLength: (max) => { // factory
        return (data, name, fieldLabel) => (data[name] && data[name].length <= max) ||
            t('maxLength', {FIELD: `${fieldLabel}`, MAX: `${max}` })
    },
    different: (anotherValKey, anotherLabel) => { // factory
        return (data, name, fieldLabel) => {
            return (data[anotherValKey] !== data[name]) || 
                t('field_different', {FIELDLABEL: `${fieldLabel}` , ANOTHERLABEL: `${anotherLabel}`})
        }
    },
    optionalFunc: (func, ignoreValues = []) => { // factory
        return (data, name, fieldLabel) => { 
            if((!data.hasOwnProperty(name) || data[name] == "" || ignoreValues.includes(data[name]))){
                return () => true;
            } else {
                return func(data, name, fieldLabel);
            }
        }
    },
};

const validateFields = (data, validations) => {
    for (const key in validations) {
        const validationFunc = validations[key].f;
        const fieldLabel = validations[key].label || key;
        let res;
        if (Array.isArray(validationFunc)) {
            res = validateMany(validationFunc, data, key, fieldLabel)
        } else {
            res = validationFunc(data, key, fieldLabel);
        }
        if (typeof res === "string") {
            return { error: res };
        }
    }
    return true;
};

const getFormatedError = (changedData, validations, colName, isNew, forceFullValidation = false) => {
    let res = null;
    let keys = Object.keys(validations);
    // full row validation
    if(!isNew || keys.indexOf(colName) === keys.length - 1 || forceFullValidation){ // do full validation 
        res = validateFields(changedData, validations);
    } else if(validations[colName]){ // only do full validation on last field edit
        let singleColValidation = {};
        singleColValidation[colName] = validations[colName];
        res = validateFields(changedData, singleColValidation);
        res = res === true ? null : res;
    }
    return res;
};

export{
    validationFunctions,
    validateFields,
    getFormatedError
}